import { Box, Stack } from '@mui/material'
import { useFormatValue } from '../../hooks/useFormatValue'
import { CardText } from '../subComponents/cardText'

interface IHotelUserDatesProps {
    startDate: string
    endDate: string
}
export const HotelUserDates = ({
    startDate,
    endDate,
}: IHotelUserDatesProps) => {
    const { formatValue } = useFormatValue()
    return (
        <Stack>
            <Box>
                <CardText variant="bodySubtext">
                    {formatValue(startDate, 'date')}
                </CardText>
                {endDate && (
                    <CardText variant="bodySubtext">
                        {' - ' + formatValue(endDate, 'date')}
                    </CardText>
                )}
            </Box>
        </Stack>
    )
}
